export default (props) => (
  <svg
    width="180"
    height="45"
    viewBox="0 0 180 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    {...props}
  >
    <g clipPath="url(#clip0_3808_16284)">
      <path
        d="M21.0465 23.3027H26.9633V18.61H31.6556V12.6927H26.9633V8H21.0465V12.6927H16.3542V18.61H21.0465V23.3027Z"
        fill="#1D1F21"
      />
      <path
        d="M38.3389 10.5335C37.506 10.2433 36.5978 10.6786 36.3047 11.5115L31.3455 25.6505C29.8655 25.7666 28.6149 26.6953 28.0403 27.9925H20.4259C19.8194 26.6198 18.4585 25.6592 16.8683 25.6389L10.4146 10.4436H1.596C0.713848 10.4436 0 11.1575 0 12.0397C0 12.9219 0.713848 13.6359 1.596 13.6359H8.30211L13.9287 26.8868C13.2642 27.5949 12.8551 28.541 12.8551 29.5886C12.8551 31.771 14.6252 33.5413 16.8074 33.5413C18.4237 33.5413 19.8078 32.572 20.423 31.1848H28.0374C28.6497 32.572 30.0368 33.5413 31.6531 33.5413C33.8352 33.5413 35.6054 31.771 35.6054 29.5886C35.6054 28.451 35.1236 27.4295 34.3547 26.7069L39.3139 12.5679C39.607 11.735 39.1688 10.8237 38.336 10.5335H38.3389Z"
        fill="#1D1F21"
      />
      <path
        d="M59.7454 20.183H50.7208V12.0601H46.635V33.2192H50.7208V23.9587H59.5162V33.2192H63.9647V12.0601H59.7454V20.183Z"
        fill="#1D1F21"
      />
      <path
        d="M74.5708 16.6453C69.6493 16.6453 66.9651 19.4052 66.9651 25.0874C66.9651 30.7697 70.9522 33.7879 75.5545 33.7879C80.1568 33.7879 81.1927 32.392 81.1927 32.392L81.0883 28.8747C81.0883 28.8747 79.7563 30.2299 76.1232 30.3692C71.1408 30.4099 71.4136 25.9784 71.4136 25.9784H81.9153V22.2521C81.9153 21.1406 80.6443 16.6453 74.5708 16.6453ZM77.8527 23.3346H71.5035V22.0286C71.5035 21.515 72.2928 19.6925 74.858 19.6925C77.4233 19.6925 77.8527 21.6572 77.8527 22.0606V23.3346Z"
        fill="#1D1F21"
      />
      <path
        d="M180 25.9756V22.2493C180 21.1378 178.729 16.6425 172.656 16.6425C167.734 16.6425 165.05 19.4024 165.05 25.0847C165.05 30.767 169.037 33.7851 173.639 33.7851C178.242 33.7851 179.278 32.3892 179.278 32.3892L179.173 28.8719C179.173 28.8719 177.841 30.2272 174.208 30.3665C169.226 30.4071 169.499 25.9756 169.499 25.9756H180ZM169.588 22.0288C169.588 21.5151 170.378 19.6926 172.943 19.6926C175.508 19.6926 175.938 21.6573 175.938 22.0607V23.3347H169.588V22.0288Z"
        fill="#1D1F21"
      />
      <path
        d="M91.9706 16.355H91.9358C89.4982 16.207 87.1129 17.0748 84.9047 18.1166C85.5547 19.1004 86.2047 20.0842 86.8547 21.068C88.3056 20.2438 89.9799 19.8201 91.6485 19.8637C92.107 19.8753 92.5858 19.9275 92.9717 20.1742C93.9583 20.8069 93.8394 22.2579 93.6043 23.4042C91.7762 23.1692 89.8929 23.0966 88.1199 23.5929C86.3469 24.0862 84.6812 25.218 83.8861 26.878C82.7196 29.3187 83.9035 32.2701 86.4803 32.9985C89.1152 33.7415 92.1592 33.0827 94.1499 31.1731C94.5126 31.9131 94.8782 32.6561 95.2409 33.3961C96.1376 33.4019 97.0343 33.4077 97.9309 33.4135C97.989 30.2009 98.0441 26.9883 98.1021 23.7728C98.1225 22.5539 98.1399 21.3031 97.7191 20.1597C96.8776 17.8786 94.3994 16.5089 91.9735 16.3521L91.9706 16.355ZM93.642 28.538C93.6188 28.5874 93.5927 28.6367 93.5637 28.686C93.2706 29.1939 92.7889 29.5654 92.2753 29.8469C91.6514 30.1864 90.9492 30.4128 90.2382 30.3925C88.413 30.3431 87.1739 28.5119 88.471 26.9767C89.0775 26.257 90.0322 25.9145 90.9666 25.8072C91.901 25.6998 92.8469 25.7926 93.7871 25.7868C93.9206 26.7097 94.0425 27.7109 93.6391 28.538H93.642Z"
        fill="#1D1F21"
      />
      <path
        d="M106.305 10.5566H101.619V33.3961H106.305V10.5566Z"
        fill="#1D1F21"
      />
      <path
        d="M131.482 16.2593C127.886 16.2593 126.56 18.1341 126.203 18.8016V10.5567H121.662V33.3962H126.203V22.6352C126.546 21.93 127.683 19.9247 129.497 19.9247C131.696 19.9247 132.477 22.1332 132.477 22.1332V33.3962H136.873V20.1597C136.873 20.1597 135.858 16.2593 131.485 16.2593H131.482Z"
        fill="#1D1F21"
      />
      <path
        d="M115.182 29.9892C114.912 29.7338 114.81 29.3507 114.738 28.988C114.607 28.3466 114.416 20.006 114.535 20.006H119.125V16.9472H114.575V13.3515H111.784C111.784 13.3515 111.247 16.2971 110.446 17.0226C109.642 17.7482 107.959 18.2851 107.959 18.2851V20.006H110.434V25.9088C110.434 29.2637 109.99 33.2279 114.384 33.6226C118.208 33.9679 119.433 32.8971 119.433 32.8971V29.8963C119.433 29.9544 116.789 30.2533 116.583 30.2823C116.096 30.3577 115.541 30.3316 115.185 29.9892H115.182Z"
        fill="#1D1F21"
      />
      <path
        d="M155.813 12.359L150.7 28.2073L145.587 12.359H143.489H139.613V33.3963H143.489V17.3129L148.684 33.3963H150.7H152.714L157.909 17.3129V33.3963H161.785V12.359H157.909H155.813Z"
        fill="#1D1F21"
      />
    </g>
    <defs>
      <clipPath id="clip0_3808_16284">
        <rect
          width="180"
          height="25.788"
          fill="white"
          transform="translate(0 8)"
        />
      </clipPath>
    </defs>
  </svg>
)
